import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/recommendations.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><strong parentName="p">{`Get however many of these cards you can`}</strong>{` (given your 5/24 status) in the order most valuable to you.`}</p>
    <p><strong parentName="p">{`Recommended application rate is 1 new Chase card every 2-3 months, depending on current offers and risk tolerance! `}</strong>{`My suggested order:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Barclays AA Biz`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Any Chase biz cards as you want to try to get`}{`*`}{` - `}<strong parentName="p"><u>{`but you maybe denied for them right now`}</u></strong></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`CSR (the CSR is always superior to the CSP if you're interested in travel)`}{`*`}{`*`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`World of Hyatt`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`United Explorer`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`SW personal card of choice`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Pick the best one for you: Chase BA Visa / IHG / Freedom Flex / Freedom Unlimited`}</p>
      </li>
    </ol>
    <p>{`(SW RRs cannot be redeemed for Amazon GCs right now, but I'm guessing that won't be the case forever.)`}</p>
    <p>{`I'd go for at least the Barclay AA Biz early on in your Chase journey, as it doesn't count against 5/24 and can be hard to get later.`}</p>
    <p><strong parentName="p"><u>{`If you are just starting out, you will probably want to stay under 5/24 indefinitely by alternating Chase apps with biz cards that don't count against 5/24, at least until you can start getting Chase biz cards again - see the WCW thread!`}</u></strong></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      